module.exports = __webpack_public_path__ + "static/img/index_jidian.16626cc7.jpg";